export const dataFeatures = [
    {
        "key": "freeUsage",
        "title": "Completely Free",
        "description": "Hesab System is currently free with no usage limits, allowing you to take full advantage of all its features without cost."
    },
    {
        "key": "cloudAI",
        "title": "Cloud-based AI",
        "description": "Powered by advanced AI in the cloud, the system continuously improves its capabilities for better performance each day."
    },
    {
        "key": "systemIntegration",
        "title": "Seamless Integration",
        "description": "Easily integrates with existing accounting and inventory systems, making it compatible with your current tools."
    },
    {
        "key": "voiceQuality",
        "title": "High-Quality Voice Interaction",
        "description": "Experience high-quality voice commands with human-like speech, powered by OpenAI voice models."
    },
    {
        "key": "supportedLanguages",
        "title": "Supports 58 Languages",
        "description": "Communicate in your preferred language with support for 58 conversational languages."
    },
    {
        "key": "dataSecurity",
        "title": "End-to-End Encryption",
        "description": "Your data is fully secured with end-to-end encryption, ensuring privacy and protection at all stages."
    },
    {
        "key": "support247",
        "title": "24/7 Support",
        "description": "Access round-the-clock support to ensure uninterrupted business operations, anytime you need help."
    },
    {
        "key": "humanSupport",
        "title": "Human Support Options",
        "description": "Get personalized assistance through phone or live chat with human agents whenever needed."
    },
    {
        "key": "usageReports",
        "title": "Detailed Usage Reports",
        "description": "Track your system usage with in-depth reports, including category breakdowns and activity levels."
    },
    {
        "key": "inventoryBranchSupport",
        "title": "Customizable Inventory Access",
        "description": "Provides inventory data to customers and branches based on access permissions."

    },
    {
        "key": "accessLevelControl",
        "title": "Customizable Access Levels",
        "description": "Control who sees what information with fully customizable data access permissions."
    },

]
